import { Tenant } from '@core/Entities/App/Tenants.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';
import { createPathFromFilters } from '@core/Utils/Search/CreatePathFromFilters';

import { applyFilterChanges } from './ApplyFiltersChange';

/**
 * Given a list of filters and a pair of range filter IDs (e.g. year__gte & year__lte) -
 * returns a function that creates a link for a set of range filters with the same value.
 * If a filter value is not selected, the link will add it.
 */
export const createFiltersLinkForRangeFilterValue = ({
  filters,
  filterIds,
  locale,
  tenant,
}: {
  filters: Filter[];
  filterIds: [FilterKey, FilterKey];
  locale: Locale;
  tenant: Tenant | undefined;
}) => {
  return (value: string) => {
    const newFilters = applyFilterChanges(filters, [
      {
        id: filterIds[0],
        value: value,
      },
      {
        id: filterIds[1],
        value: value,
      },
    ]);
    const path = createPathFromFilters(newFilters ?? [], locale, 'autos');

    if (!tenant) return path;

    // strip the locale from the path
    const split = path.split('/').filter(Boolean);
    if (split.at(0) === locale) return '/' + split.slice(1).join('/');

    return path;
  };
};
